/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id/rename" endpoint.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsBaseCreativeRenameCacheKeys } from "./constants";
import type {
  DecisioningStudioAgentsBaseCreativeRenameResult,
  PutDecisioningStudioAgentsBaseCreativeRenameProps,
} from "./types";

export const putDecisioningStudioAgentsBaseCreativeRename = reactQueryMutationAdapter(
  decisioningStudioAgentsBaseCreativeRenameCacheKeys,
  ({
    appGroupId,
    dsaId,
    campaignId,
    name,
  }: PutDecisioningStudioAgentsBaseCreativeRenameProps): Promise<DecisioningStudioAgentsBaseCreativeRenameResult> =>
    fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/base_creatives/${campaignId}/rename`, "PUT", { name })
);
